import { FlightSegment, Provider } from '@prisma/client';
import { uniqBy } from 'lodash';

export const providers = <T extends FlightSegment & { provider: Provider }>(flightSegments: T[]): Provider[] => {
  const providers = flightSegments.map((node) => node.provider);
  return uniqBy(providers, 'id');
};
